export class TireVendor {
    id!: string
    name!: string
    contactName?: string
    phone?: string
    email?: string
    notes?: string
    vistaVendor?: number | null
    vistaFirmNumber?: number | null
    vistaFirmContactCode?: number | null
    archived!: boolean
    resolvedContactName?: string
    resolvedPhone?: string
    resolvedEmail?: string
    resolvedLocation?: string
    contactSource?: string
}

export class TireVendorRoute {
    id!: string
    county!: string
    countyDisplay?: string
    equipmentClass!: string
    rank!: number
    tireVendorId!: string
    tireVendorName?: string
    serviceAreaNotes?: string
    archived!: boolean
    vendorPhone?: string
    vendorLocation?: string
}

export class EquipmentTireConfig {
    id!: string
    equipment!: string
    axleNumber!: number
    side!: string
    tireSize!: string
    positionLabel?: string
    notes?: string
    archived!: boolean
}

export interface TireVistaVendorSearchResult {
    vendor: number
    name: string
    contact?: string
    phone?: string
    email?: string
    address?: string
    city?: string
    state?: string
}

export interface TireVistaFirmContactSearchResult {
    contactCode: number
    firstName?: string
    lastName?: string
    phone?: string
    mobilePhone?: string
    email?: string
}

export interface TireVistaFirmSearchResult {
    firmNumber: number
    name: string
    firmType?: string
    phone?: string
    email?: string
    city?: string
    state?: string
    contacts: TireVistaFirmContactSearchResult[]
}
